import{f as n,w as e}from"./chunk-IHVDOCQS.js";import{e as m,m as r}from"./chunk-HBP5N4FR.js";import{TokenPayment as i}from"@multiversx/sdk-core";function b(o,t=n){return i.fungibleFromAmount("",o,t).toString()}var u=m(()=>{r();e()});export{b as a,u as b};
//# sourceMappingURL=chunk-G5NR5AB7.js.map
